import CustomersApi from "../../apis/Customers";
import { addIndexedDb } from "../../indexDB";
import { getAllIndexedDb } from "../../indexDB";

export default {
  namespaced: true,
  state: {
    customers: [],
    customer_selected: {},
    person: null,
    file_name: null,
    paginated:{}
  },
  mutations: {
    set_customers(state, customers) {
      state.customers = customers;
    },
    set_customer(state, customer) {
      state.customer_selected = customer;
    },
    set_person(state, data) {
      state.person = data;
    },
    set_file_name(state, value) {
      state.file_name = value;
    },
    set_paginated (state, data) {
      state.paginated =  data
  }
  },
  actions: {
    setCustomer({ commit }, customer) {
      commit("set_customer", customer);
    },
    setCustomers({ commit }, customers) {
      commit("set_customers", customers);
    },
    async getCustomers({ commit, dispatch }, filters) {

      return await CustomersApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated', {
            ...response.data
          })
          commit("set_customers", response.data.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar clientes, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async store({ dispatch }, customer) {
      return await CustomersApi.store(customer)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getCustomers");
          dispatch("sales/select_customer", response.data, { root: true });
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message =
            "Ocurrió un error al registrar cliente, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async update({ dispatch }, customer) {
      return await CustomersApi.update(customer)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta",
            },
            { root: true }
          );
          dispatch("getCustomers");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al actualizar cliente, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, customer) {
      let action = customer.active ? "inactivación" : "activación";
      return await CustomersApi.change_status(customer)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getCustomers");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, customer) {
      return await CustomersApi.delete(customer)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getCustomers");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    emptyPerson({ commit }) {
      commit("set_person", null);
    },
    async searchDocument({ commit, dispatch }, document) {
      return await CustomersApi.search_document(document)
        .then((response) => {
          commit("set_person", response.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "No se encontró número de documento";
          if (error.response.data.error_message) {
            message = error.response.data.error_message;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async downloadCustomers({ commit, dispatch }, filters) {
      commit("set_file_name", null);
      return await CustomersApi.download(filters)
        .then((response) => {
          commit("set_file_name", response.data.file_name);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: "Ocurrió un error al descargar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async upload({ dispatch }, customer) {
      return await CustomersApi.upload(customer)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message:
                "Los reactivos del archivo se registraron de forma correcta.",
            },
            { root: true }
          );
          dispatch("getCustomers");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message =
            "Ocurrió un error al registrar productos del archivo, vuelva a intentarlo.";
          if (error.response.data && error.response.data.message) {
            message = error.response.data.message;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
  },
};
